<template>
<el-container>
  <div v-if="ismobile === false">
    <publicHeader :currencyShow="currencyShow" @hotelLanguage="hotelLanguage"></publicHeader>
  </div>
  <div v-else>
    <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
      <router-link :to="{name:'Home'}">
        <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
      </router-link>
      <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('myFavorite')}}</div>
    </div>
  </div>
  <el-main>
    <div class="main" :style="{ 'min-height': `${elementHeight}px` }">
          <publicAccountMenu></publicAccountMenu>

          <!-- 我的行程 -->
          <div class="account-show">
              <div class="account-center">
                  <div class="account-data-info">
                      <div class="clearBoth account-roominfo-clear"></div>
                      <div class="home-collection">
                        <div class="home-collection-empty" v-show="collectionEmptyShow">
                          <div><img src="https://res.roompai.com/static/img/account/collect-no.png" class="empty-img"></div>
                          <div class="empty-text">
                            <div>{{$t('noFavoriteHotelAddFavorite')}}</div>
                            <div>
                              <router-link :to="{ name: 'Home'}">
                                <el-button :class="'home_button_'+language">{{$t('backHome')}}</el-button>
                              </router-link>
                            </div>
                          </div>
                        </div>
                        <div class="coll-collection-pc">
                          <div v-if="ismobile === false">
                            <el-skeleton :count="3" animated :loading="listShow">
                              <template slot="template">
                                <el-row>
                                  <el-col :span="6" class="row-col" v-for="key in 4" :key="key">
                                    <el-card style="height:340px;"  :class="{'marginnone': parseInt(key)%4 === 0}">
                                      <div class="collect-img">
                                        <span style="cursor: pointer;">
                                          <el-skeleton-item variant="text" class="hotel-image"/>
                                        </span>
                                      </div>
                                      <div class="hotel-infos">
                                        <span class="hotel-name">
                                          <el-skeleton-item variant="text"/>
                                          <el-skeleton-item variant="text"/>
                                        </span>
                                        <span class="hotel-star"><el-skeleton-item variant="text" style="width:100px;"/></span>
                                        <span class="hotel-addr">
                                          <el-skeleton-item variant="text"/>
                                          <el-skeleton-item variant="text"/>
                                        </span>
                                        <div class="hotel-price"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                      </div>
                                    </el-card>
                                  </el-col>
                                </el-row>
                              </template>
                              <template>
                                <el-card :body-style="{ padding: '0px' }">
                                  <el-row>
                                    <el-col :span="6" class="row-col" v-for="(value, key) in myCollectList" :key="key">
                                      <el-card style="height:340px;"  :class="{'marginnone': parseInt(key)%4 === 0}">
                                        <div class="collect-img">
                                          <span style="cursor: pointer;" @click="jumpDetail(value.hotelid, value.hotelname_lang, value.zDateTime)">
                                            <div v-if="value.pic !== ''">
                                              <img :src="value.pic" class="hotel-image">
                                            </div>
                                            <div v-else>
                                              <img :src="value.dpic" class="hotel-image">
                                              <div class="no-room-img text-font-hidden">{{$t('nopic')}}</div>
                                            </div>
                                          </span>
                                          <!-- <div :class="'home-like-'+value.islike" @click="collect(value.hotelid, value.islike)"></div> -->
                                          <svg @click="collect(value.hotelid, value.islike)" :class="'home-like-'+value.islike" id="heart" viewBox="-2 0 105 92" data-love-level="0">
                                            <path d="M85.24 2.67C72.29-3.08 55.75 2.67 50 14.9 44.25 2 27-3.8 14.76 2.67 1.1 9.14-5.37 25 5.42 44.38 13.33 58 27 68.11 50 86.81 73.73 68.11 87.39 58 94.58 44.38c10.79-18.7 4.32-35.24-9.34-41.71z"></path>
                                          </svg>
                                        </div>
                                          <div class="hotel-infos" @click="jumpDetail(value.hotelid, value.hotelname_lang, value.zDateTime)">
                                            <span class="hotel-name">
                                              <el-tooltip :content="value.hotelname" placement="top" effect="dark" popper-class="atooltip" class="tipinfo">
                                                <span>{{value.hotelname_short}}</span>
                                              </el-tooltip>
                                            </span>
                                            <span class="hotel-star">
                                              <b style="margin-right: 3px;" v-for="n in parseInt(value.star)" :key="n">
                                                <img style="width:15px;height:15px;" src="/static/img/star.png">
                                              </b>
                                              <b style="margin-left: -3px;" v-if="value.star_decimal === 1">
                                                <img style="width:15px;height:15px;" src="/static/img/star-decimal.png">
                                              </b>
                                            </span>
                                            <span class="hotel-addr" v-if="language === 'en'">
                                              <el-tooltip :content="value.hoteladdress" placement="top" effect="dark" popper-class="atooltip" class="tipinfo">
                                                <span>{{value.hoteladdress_short}}</span>
                                              </el-tooltip>
                                            </span>
                                            <span class="hotel-addr" v-else>
                                              <el-tooltip :content="value.hoteladdress_zh" placement="top" effect="dark" popper-class="atooltip" class="tipinfo">
                                                <span>{{value.hoteladdress_short_zh}}</span>
                                              </el-tooltip>
                                            </span>
                                            <div class="hotel-price">
                                              <span v-if="value.price > 0">
                                                <span style="font-size:10px; font-weight:400;display: inline-block;">{{resultCurrency}}</span> {{value.price}}
                                              </span>
                                            </div>
                                          </div>
                                      </el-card>
                                    </el-col>
                                  </el-row>
                                </el-card>
                              </template>
                            </el-skeleton>
                          </div>
                          <div class="coll-collection-center" v-else>
                            <div class="coll-collection-mobile">
                              <el-skeleton :count="8" animated :loading="listShow">
                                <template slot="template">
                                  <el-row>
                                    <el-col>
                                      <el-card style=" margin-bottom: 5px;">
                                        <div class="collect-img">
                                          <span style="cursor: pointer;"><el-skeleton-item variant="text" style="width: 100%; height: 90px;"/></span>
                                        </div>
                                        <div class="hotel-infos">
                                          <span class="hotel-name">
                                            <el-skeleton-item variant="text"/>
                                          </span>
                                          <span style="height:20px;"></span>
                                          <div class="hotel-price"><el-skeleton-item variant="text" style="width: 100px;float: right;"/></div>
                                        </div>
                                      </el-card>
                                    </el-col>
                                  </el-row>
                                </template>
                                <template>
                                  <el-row>
                                    <el-col :span="12" class="row-col" v-for="(value, key) in myCollectList" :key="key">
                                      <el-card >
                                        <div class="collect-img">
                                          <span style="cursor: pointer;">
                                            <div class="picinfo" v-if="value.pic !== ''">
                                              <img :src="value.pic" class="hotel-image">
                                            </div>
                                            <div class="picinfo" v-else>
                                              <img :src="value.dpic" class="hotel-image">
                                              <div class="no-room-img text-font-hidden">{{$t('nopic')}}</div>
                                            </div>
                                          </span>
                                          <svg @click="collect(value.hotelid, value.islike)" :class="'home-like-'+value.islike" id="heart" viewBox="-2 0 105 92" data-love-level="0">
                                            <path d="M85.24 2.67C72.29-3.08 55.75 2.67 50 14.9 44.25 2 27-3.8 14.76 2.67 1.1 9.14-5.37 25 5.42 44.38 13.33 58 27 68.11 50 86.81 73.73 68.11 87.39 58 94.58 44.38c10.79-18.7 4.32-35.24-9.34-41.71z"></path>
                                          </svg>
                                        </div>
                                        <div class="hotel-infos" @click="jumpDetail(value.hotelid, value.hotelname_lang, value.zDateTime)">
                                          <span class="hotel-name">
                                            <el-tooltip :content="value.hotelname" placement="top" effect="dark" popper-class="atooltip" class="tipinfo">
                                              <span>{{value.hotelname_short}}</span>
                                            </el-tooltip>
                                          </span>
                                          <span style="height:20px;"></span>
                                          <div class="hotel-price">
                                            <span v-if="value.price > 0">
                                              <span style="font-size:10px; font-weight:400;display: inline-block;">{{resultCurrency}}</span> {{value.price}}
                                            </span>
                                          </div>
                                        </div>
                                      </el-card>
                                    </el-col>
                                  </el-row>
                                </template>
                              </el-skeleton>
                            </div>
                          </div>
                          <!--分页 开始-->
                          <div class="hotelpages" v-show="!listShow">
                            <div class="hotel-totaltext">
                              <span v-if="language === 'zh'">共</span>
                              <span class="hotelnum">{{listTotal}}</span>
                              {{$t('properties')}}
                            </div>
                            <div class="pageinfo">
                              <div class="block">
                                <el-pagination :page-size="pageSize" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :pager-count="7" layout="prev, pager, next" :total="listTotal" :current-page="currentPage"></el-pagination>
                              </div>
                            </div>
                          </div>
                          <!--分页 结束-->
                        </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </el-main>
  <div class="clearBoth"></div>
  <publicFooter></publicFooter>
</el-container>
</template>

<script>
import { myCollect, doCollect } from '@/request/collect.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import publicAccountMenu from '@/components/public/publicAccountMenu'
export default {
  name: 'myCollection',
  components: {
    publicFooter,
    publicHeader,
    publicAccountMenu
  },
  data () {
    return {
      orderno: '',
      currentPage: 1, // 当前默认显示第几页
      listTotal: 0, // 分页总条数
      pageSize: 20, // 每页显示多少条数据，记住这里一定要是10的倍数，不然无效
      myCollectList: {},
      collectionShow: true,
      collectionEmptyShow: false,
      language: this.common.languageSet(this),
      currency: this.common.currencySet(this),
      elementHeight: 0,
      ismobile: false,
      resultCurrency: '',
      start: '',
      end: '',
      currencyShow: false,
      listShow: true
    }
  },
  created () {
    this.beforeMount()
  },
  mounted: function () {
    if (document.documentElement.clientWidth < 1100) {
      this.ismobile = true
    } else {
      this.ismobile = false
    }
    var token = localStorage.getItem('token')
    if (token === undefined || token === null || token === 'null') {
      let locationHref = window.document.location.href
      sessionStorage.setItem('LoginWebsiteAddress', locationHref)
      this.$router.push({name: 'login'})
    }
    var date1 = new Date()
    date1.setDate(date1.getDate() + 1)
    var date2 = new Date(date1)
    date2.setDate(date1.getDate() + 1)
    this.start = (date1.getFullYear()) + '-' + (date1.getMonth() + 1) + '-' + (date1.getDate())
    this.end = (date2.getFullYear()) + '-' + (date2.getMonth() + 1) + '-' + (date2.getDate())
    this.getMyCollect(1)
  },
  watch: {
    currency: function (newCur, oldCur) {
      this.getMyCollect(this.currentPage)
    },
    language: function (newCur, oldCur) {
      this.getMyCollect(this.currentPage)
    }
  },
  methods: {
    beforeMount () {
      this.elementHeight = document.documentElement.clientHeight || document.body.clientHeight
    },
    hotelDetailCurrency (currency) {
      this.currency = currency
    },
    hotelLanguage (language) {
      this.language = language
    },
    handleClick: function () {

    },
    // 分页 size-change  pageSize 改变时会触发 每页条数
    handleSizeChange (val) {
      this.currentPage = val
      this.getMyCollect(val) // 引入你要加载的数据函数
    },
    // current-change  currentPage 改变时会触发  当前页
    async handleCurrentChange (val) {
      this.currentPage = val
      this.start = (val - 1) * this.pageSize // （val-1）是我自己的项目需要，一般写val即可
      this.getMyCollect(val)
    },
    getMyCollect (page) {
      this.common.stopScroll()
      this.listShow = true
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined) {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        this.$router.push({name: 'login'})
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'pageSize': this.pageSize, 'page': page, 'time': time, 'language': this.language, 'token': token, 'sessionid': sessionid, 'currency': this.currency}
      var data = this.common.encryptionData(dataJson, this)
      myCollect(data).then(res => {
        if (res.flag === '001') {
          let locationHref = window.document.location.href
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          this.$router.push({name: 'login'})
        } else if (res.flag === '200' && res.data !== '') {
          this.myCollectList = res.data.list
          this.listTotal = parseInt(res.data.totalNum)
          this.currentPage = parseInt(res.data.currentPage)
          this.pageSize = parseInt(res.data.pageSize)
          this.resultCurrency = res.data.currency
          this.collectionShow = true
          this.collectionEmptyShow = false
          this.listShow = false
          this.common.canScroll()
        } else {
          this.myCollectList = {}
          this.collectionShow = false
          this.collectionEmptyShow = true
          this.listShow = false
          this.common.canScroll()
        }
      })
    },
    collect (key, islike) {
      var dolike = parseInt(islike) === 1 ? 0 : 1
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined) {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        this.$router.push({name: 'login'})
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'hotelid': key, 'status': dolike, 'time': time, 'language': this.language, 'token': token, 'sessionid': sessionid}
      var data = this.common.encryptionData(dataJson, this)
      console.log(data)
      doCollect(data).then(res => {
        console.log(res)
        if (res.flag === '200') {
          this.getMyCollect(this.currentPage)
        }
      })
    },
    jumpDetail (hotelid, hotelname, zDateTime) {
      // 获取当前日期
      // let d = new Date()
      // var year = d.getFullYear()
      // var month = d.getMonth()
      // var tian = d.getDate()
      // var dayNum = new Date(year, parseInt(month) + 1, 0).getDate()
      // var startDate = tian
      // var endDate = tian + 1
      // var startMonth = month
      // var endMonth = month
      // var startYear = year
      // var endYear = year
      // if (startDate > dayNum) {
      //   startDate = parseInt(startDate) - parseInt(dayNum)
      //   startMonth += 1
      // }
      // if (endDate > dayNum) {
      //   endDate = parseInt(endDate) - parseInt(dayNum)
      //   endMonth += 1
      // }
      // if (startMonth >= 12) {
      //   startMonth = 0
      //   startYear += 1
      // }
      // if (endMonth >= 12) {
      //   endMonth = 0
      //   endYear += 1
      // }
      // var monthStartSelect = (startMonth + 1) < 10 ? '0' + (startMonth + 1).toString() : (startMonth + 1).toString()
      // var monthEndSelect = (endMonth + 1) < 10 ? '0' + (endMonth + 1).toString() : (endMonth + 1).toString()
      // var startDateSelect = startDate < 10 ? '0' + startDate.toString() : startDate.toString()
      // var endDateSelect = endDate < 10 ? '0' + endDate.toString() : endDate.toString()
      // var start = startYear + '-' + monthStartSelect + '-' + startDateSelect
      // var end = endYear + '-' + monthEndSelect + '-' + endDateSelect
      const newdate = new Date(zDateTime)
      newdate.setDate(newdate.getDate() + 1)
      const newDateStr = newdate.toISOString().split('T')[0]
      var detailjson = {}
      detailjson['hotelid'] = hotelid
      detailjson['region'] = hotelname
      detailjson['start_date'] = zDateTime
      detailjson['end_date'] = newDateStr
      detailjson['room'] = 1
      detailjson['adult'] = 2
      detailjson['child'] = 0
      detailjson['language'] = this.language
      detailjson['currency'] = this.currency
      this.$router.push({name: 'HotelDetail', query: detailjson})
    }
  }
}
</script>

<style scoped>
.el-main{text-align: left;}
.home_button_zh{width:96px;height:36px;font-size:14px; border:none;border-radius:4px; text-decoration:none;background-color:#4F4C4C;color:#FFF; margin-top:20px;}
.home_button_en{width:159px;height:36px;font-size:14px; border:none;border-radius:4px; text-decoration:none;background-color:#4F4C4C;color:#FFF; margin-top:20px;}
.home_button_en:hover,.home_button_zh:hover{background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);}
.main{background-color: #fff;width:100%;position:relative;background:#FFFFFF;}
.marginnone{margin-right:0px !important;}
/* 右侧 */
.account-show{width: 100%; height: 100%;background:#F2F2F2;}
.account-show .account-center{width: 82%;height:100%; float:right;background: #FFFFFF;}
.account-center .account-data-info{width:100%;height:100%;margin:0 auto;}
.account-data-info .home-collection{width:100%;margin-bottom:20px;}

/* 收藏 */
.home-collection-empty{width:80%;margin:0 auto;min-height:600px;text-align: center;padding-top: 60px;}
.empty-text{font-size: 16px;font-weight: 500; color: #4F4C4C;text-align: center; margin-top: 10px;}
.empty-img{width:260px; height:260px;}
.coll-collection-pc .el-card {margin-right:10px;}
.coll-collection-pc .picinfo{position:relative; width:100%;height:100%;}
.coll-collection-pc .picinfo .no-room-img{bottom:45px;height:35px;line-height:35px;}
.coll-collection-pc .picinfo .text-font-hidden{position:absolute;bottom:12px;width:100%;font-size: 14px;color: #FFFFFF;border-radius:0px 0px 4px 4px;background:rgba(70, 37, 36, 0.5);cursor:pointer;
      text-align: center;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.coll-collection-pc .hotel-star{color:#FCD205; height:30px;}

.coll-collection-pc{width:100%;margin:0 auto;}
.coll-collection-pc /deep/ .el-card__body{padding:0px !important;}
.coll-collection-pc .row-col{width:25%;margin-bottom:20px;}
.el-card {margin-right:5px;}
.collect-img{position: relative;top:0px;left:0px;width:100%;}
.collect-img .home-love{position:absolute;top:5px;right:5px;width:35px;height:25px;cursor:pointer;}
.coll-collection-pc .row-col .hotel-image{width:100%; height:151px;}
.coll-collection-pc .row-col .no-room-img{bottom:45px;height:35px;line-height:35px;}
.coll-collection-pc .row-col .text-font-hidden{position:absolute;bottom:12px;width:100%;font-size: 14px;color: #FFFFFF;border-radius:0px 0px 4px 4px;background:rgba(70, 37, 36, 0.5);cursor:pointer;
      text-align: center;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.hotel-infos{padding: 0px 10px; cursor: pointer;}
.hotel-infos span{display:block;}
a span, a div{text-decoration: underline}
.hotel-name{font-weight: 500;font-style: normal;font-size: 12px;color: #4F4C4C; height:50px;margin-top:8px;}
.hotel-star{color:#FCD205;}
.hotel-addr{font-size: 8px;color: #4F4C4C;font-weight: 100;min-height:40px;}
.hotel-br{height:25px;}
.hotel-price{text-align:right;font-weight: 650;font-style: normal;font-size: 18px;color: #E12D2D;margin: 10px 5px;}

.account-roominfo-clear{height:20px;width:100%;}
.hotelpages div{display: inline-block;}
.hotelpages{margin-top: 100px;margin-bottom: 20px;}
.hotel-totaltext{font-size: 14px;font-weight:400;color:#4F4C4C;width:30%;}
.hotel-totaltext span{font-weight:650;color:#5392F9;}
.pageinfo{width:68%;text-align:right;}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
  background-color:#F2F2F2;
}
.coll-collection-pc .collect-img{position: relative;top:0px;left:0px;width:100%;}
.coll-collection-pc .collect-img .home-like-1{width:30px;height:30px;cursor: pointer;fill:red;position:absolute;top:5px;right:5px;}
.coll-collection-mobile .coll-img{position: relative;top:0px;left:0px;width:30%;height:100%;float:left;}
.coll-collection-mobile .coll-img .coll-like-1{width:30px;height:30px;cursor: pointer;fill:red;position:absolute;top:5px;right:5px;}
.coll-collection-mobile .picinfo{position:relative; width:100%;height: 100%;}
.coll-collection-mobile .picinfo .no-room-img{bottom:45px;height:35px;line-height:35px;}
.coll-collection-mobile .picinfo .text-font-hidden{position:absolute;bottom:12px;width:100%;font-size: 14px;color: #FFFFFF;border-radius:0px 0px 4px 4px;background:rgba(70, 37, 36, 0.5);cursor:pointer;
      text-align: center;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.coll-collection-mobile .hotel-name{font-weight: 500;font-style: normal;font-size: 12px;color: #4F4C4C; min-height:40px;line-height: 40px;padding:0px 10px;}
.coll-collection-mobile .hotel-name span{white-space: nowrap;text-overflow: ellipsis;overflow: hidden;}
.coll-collection-mobile .hotel-star{color:#FCD205; height:30px;}
.coll-collection-mobile .hotel-addr{font-size: 8px;color: #4F4C4C;font-weight: 100; min-height:40px;}
.coll-collection-mobile .hotel-br{height: 25px;}
.coll-collection-mobile .hotel-height15{height: 15px;}
.coll-collection-mobile .hotel-price{text-decoration:none;text-align:right;font-weight: 650;font-style: normal;font-size: 18px;color: #E12D2D;margin: 0px 20px 0px 0px;}
.coll-collection-mobile .hotel-infos{padding: 0px;width:70%;float:left;height:90px; text-decoration: none;}
.coll-collection-mobile a{text-decoration:none;}
.coll-collection-mobile .hotel-infos span{display:block;text-decoration:none;}
/* .coll-collection-mobile .hotel-infos:hover,.coll-collection-mobile .hotel-infos:focus,.coll-collection-mobile .hotel-infos:visited{background-color: rgb(0 0 0 / 8%);} */
.coll-collection-center .coll-collection-mobile .row-col .hotel-image{width:100%; height:100%;}
.coll-collection-mobile .row-col .el-card__body{height:90px !important;}
/* .el-pagination /deep/ button:disabled, .el-dialog, .el-pager /deep/ li{ background-color:#F2F2F2;}
.el-pagination /deep/ .btn-next, .el-pagination /deep/ .btn-prev{ background:center center no-repeat #F2F2F2;} */
/* 响应式 */
  @charset "UTF-8";

  /* @media only screen and (max-width:550px){
      .main .menu-main{display:none}
      .main .account-show .account-center{width:100%;}
      .main .account-show .account-center .account-data-info{width:95%;}

      .coll-collection-pc .row-col{width:100%;}
  }

  @media only screen and (min-width:550px) and (max-width:790px){
      .main .menu-main{display:none}
      .main .account-show .account-center{width:100%;}
      .main .account-show .account-center .account-data-info{width:95%;}

      .coll-collection-pc .row-col{width:50%;}
  } */

  @media screen and (max-width: 1099px) {
    .main .menu-main{display:none}
    .main .account-show .account-center{width:100%;}
    .main .account-show .account-center .account-data-info{width:95%;}
    .coll-collection-pc .el-card{height:90px !important;}
    .coll-collection-pc .row-col{width:100%;}
    .coll-collection-pc .collect-img{width: 30%;float: left; height:90px;}
    .hotel-name{margin: 0; height: 40px;}
    .coll-collection-pc .row-col{margin-bottom: 5px;}
    .coll-collection-pc .el-card{margin: 0;}
  }

  @media only screen and (min-width:1100px){
    .el-main{width:1100px;margin:60px auto;}
    .main{background-color: #fff;position:relative;width:100%; margin: auto;}
    /* .menu-main{width: 255px;height: 100%;float: left;background-color: rgba(255, 255, 255, 1);border-right: none;-webkit-box-shadow: 0 2px 12px #ccc;box-shadow: 4px -2px 5px -3px #ccc;position: fixed;top: 60px;bottom: 300px;} */
    .menu-main{width: 255px;float: left;position: fixed;top: 60px;bottom: 360px;height: 100%}
    .main .account-show .account-center{width:100%;}
    .main .account-show .account-center .account-data-info{width:100%;}
    .main .account-show .account-center .account-data-info .account-order-pc{}
    .main .account-show .account-center .account-data-info .account-order-mobile{display:none;}
    .account-show{width: 825px; height: 100%;background:#FFFFFF;float: right;padding: 0 10px;}
    .coll-collection-pc .row-col{width:25%;}
  }
</style>
<style lang="css" scoped>
.el-tooltip__popper{max-width:185px !important;}
</style>



// WEBPACK FOOTER //
// src/components/account/myCollection.vue